<script setup>
import axios  from "axios";
import Confirm from '@/components/confirm/Confirm.vue'
import Load from '@/components/common/Load.vue'
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
	<v-card
        max-width="800px"
        flat
        style="margin : 0 auto;"
        class="mb-1"
	>
		<v-card-text class="px-0">
		<Confirm v-if="load_flg == true" />	
		<Load v-else />
		</v-card-text>
	</v-card>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'リリース確認',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
    link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "./css/editor.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
   },
	computed : {
        doctitle : function() {
             return this.$store.getters['doc_info/get_title'];
        },
	},
	data : function(){
		return {
			id : "",
			load_flg : false,
		};
	},
	created : async function(){
        await axios.post("/doc/get_confirm",null)
        .then(response => {
            if(response.data.length > 0)
            {
                let signature = response.data[0].signature;
                if(response.data[0].company_name != "" && response.data[0].company_name != null)
                {
                    signature = response.data[0].company_name + "\n" + response.data[0].signature;
                }
                this.$store.commit("doc_info/set_val",{
                    "doc_id"        : response.data[0].id,
                    "title"         : response.data[0].title,
                    "sub_title"     : response.data[0].sub_title,
                    "summary"       : response.data[0].summary,
                    "doc"           : response.data[0].doc,
                    "direction"     : response.data[0].direction,
                    "signature"     : signature,
                    "conf_id"       : response.data[0].conf_id,
                    "schedule_id"   : response.data[0].schedule_id,
                    "release_date"  : response.data[0].release_date,
                    "product_id"    : response.data[0].product_id,
                    "therm"         : response.data[0].therm,
                    "docstatus"     : response.data[0].status,
                    "uuid"          : response.data[0].uuid,
                    "temp_id"       : response.data[0].temp_id,
                });
                this.load_flg=true;
            }
			else
			{
				window.location.href="https://qlipper.jp/doc/";
			}
        })
        .catch((error) => {
                console.error('失敗です', error);
        });

	},
}
</script>
